import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LOGO_URL } from "@/data/homeContent";
import { Lock, Loader2 } from "lucide-react";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate("/admin", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/admin", { replace: true });
    else setError(res.error);
  };

  return (
    <div className="min-h-screen bg-[#2a0a12] flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-8">
          <img src={LOGO_URL} alt="BSD" className="h-12 bg-white rounded px-2 py-1" />
        </div>
        <div className="bg-white rounded-2xl shadow-2xl p-8">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-11 w-11 rounded-lg bg-[#800020]/10 flex items-center justify-center"><Lock className="h-5 w-5 text-[#800020]" /></span>
            <div>
              <h1 className="font-serif text-2xl text-slate-900">Admin Portal</h1>
              <p className="text-sm text-slate-500">Sign in to manage listings</p>
            </div>
          </div>
          <form onSubmit={submit} className="space-y-4">
            <label className="block">
              <span className="block text-sm font-medium text-slate-700 mb-1.5">Email</span>
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="w-full border border-slate-300 rounded-lg px-3.5 py-2.5 text-sm outline-none focus:border-[#800020] focus:ring-1 focus:ring-[#800020]" data-testid="admin-login-email-input" />
            </label>
            <label className="block">
              <span className="block text-sm font-medium text-slate-700 mb-1.5">Password</span>
              <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="w-full border border-slate-300 rounded-lg px-3.5 py-2.5 text-sm outline-none focus:border-[#800020] focus:ring-1 focus:ring-[#800020]" data-testid="admin-login-password-input" />
            </label>
            {error && <p className="text-sm text-red-600" data-testid="admin-login-error">{error}</p>}
            <button type="submit" disabled={loading} className="w-full inline-flex items-center justify-center gap-2 px-6 py-3 rounded-lg bg-[#800020] hover:bg-[#660019] text-white font-medium transition-colors disabled:opacity-60" data-testid="admin-login-submit-btn">
              {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : null} Sign In
            </button>
          </form>
        </div>
        <p className="text-center text-xs text-slate-400 mt-6">BSD Boarding School Directory · Admin Access</p>
      </div>
    </div>
  );
}
